import { jwtDecode } from "jwt-decode";

const TOKEN_KEY = "token";
let logoutTimer = null;

/* ======================
   TOKEN
====================== */
export function setToken(token) {
  if (!token) return;

  localStorage.setItem(TOKEN_KEY, token);
  startExpiryTimer(token);
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

/* ======================
   LOGOUT
====================== */
export function logout() {
  localStorage.removeItem(TOKEN_KEY);

  if (logoutTimer) {
    clearTimeout(logoutTimer);
    logoutTimer = null;
  }

  // hard redirect prevents ghost state
  window.location.replace("/login");
}

/* ======================
   JWT HELPERS
====================== */
export function getRoleFromToken() {
  const token = getToken();
  if (!token) return null;

  try {
    return jwtDecode(token)?.role || null;
  } catch {
    return null;
  }
}

/* ======================
   EXPIRY HANDLING
====================== */
function startExpiryTimer(token) {
  if (logoutTimer) {
    clearTimeout(logoutTimer);
    logoutTimer = null;
  }

  let decoded;
  try {
    decoded = jwtDecode(token);
  } catch {
    logout();
    return;
  }

  if (!decoded?.exp) {
    logout();
    return;
  }

  const expiresAt = decoded.exp * 1000;
  const remainingMs = expiresAt - Date.now();

  if (remainingMs <= 0) {
    logout();
    return;
  }

  // 🔥 ONLY ONE TIMER – EXACT EXPIRY
  logoutTimer = setTimeout(logout, remainingMs);
}

/* ======================
   INIT ON APP LOAD
====================== */
export function initAuthFromStorage() {
  const token = getToken();
  if (!token) return;

  let decoded;
  try {
    decoded = jwtDecode(token);
  } catch {
    logout();
    return;
  }

  if (Date.now() >= decoded.exp * 1000) {
    logout();
  } else {
    startExpiryTimer(token);
  }
}
